import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "../../analytics";

/** Logs a Firebase Analytics page_view on every route change. */
export default function Analytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    logPageView(pathname);
  }, [pathname]);
  return null;
}
